/**
 * Collection Landing — FAQ accordion helpers.
 * Markup prefers native <details>/<summary>; this syncs exclusive-open
 * behavior when data-cl-faq-exclusive is set, and keeps icons in sync.
 */
(function () {
  function initFaq(root) {
    if (!root || root.dataset.clFaqReady === 'true') return;
    root.dataset.clFaqReady = 'true';

    var items = root.querySelectorAll('details.cl-faq__item');
    if (!items.length) return;

    var exclusive = root.getAttribute('data-cl-faq-exclusive') === 'true';

    items.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open || !exclusive) return;
        items.forEach(function (other) {
          if (other !== details && other.open) {
            other.open = false;
          }
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cl-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-cl-faq]');
    if (root) {
      root.dataset.clFaqReady = 'false';
      initFaq(root);
    }
  });
})();
